import React, {Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Login from './Login';
import Calendar from './Calendar'
import Reservation from './Reservation'
import ReservationManage from './ReservationManage'
import CheckedInManage from './CheckedInManage'
import InputOrder from './InputOrder'
import IssueReceipts from './IssueReceipts'
import CheckedOutManage from './CheckedOutManage'
import SearchCustomers from './SearchCustomers'
import Config from './Config'
import UserManage from './UserManage'
import ExtraPlans from './ExtraPlans'
import { BrowserRouter, Route, Switch, Redirect, Link } from 'react-router-dom'
import PrivateRoute from './PrivateRoute'
import AuthService from './services/AuthService'
import SvgIcon from 'react-icons-kit';
import {glass} from 'react-icons-kit/icomoon/glass'
import { calendar, phone, checkSquareO, listUl, bellO, gear, fileTextO, user, users, leaf} from 'react-icons-kit/fa/'
import ExitToApp from '@material-ui/icons/ExitToApp';

const drawerWidth = 240;

const styles = theme => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: '#3c3c3c'
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    backgroundColor: '#d2d2d2',
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing.unit * 5 + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 7 + 1,
    },
    backgroundColor: '#d2d2d2',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    paddingLeft: theme.spacing.unit * 9,
    paddingTop: theme.spacing.unit * 6,
    paddingRight: theme.spacing.unit * 3,
    paddingBottom: theme.spacing.unit * 6,
    backgroundColor: '#f1f1f1',
    width: '100vw',
    minHeight: '100vh'
  },
});

class App extends React.Component {
  constructor(props) {
    super(props);
    this.authApi = new AuthService()
  }

  state = {
    open: false,
    nickname:"",
    path: ""
  }

  setPath(){
    this.setState({
      path: window.location.pathname,
    })
  }

  setNickname(){
    this.authApi.getNickname()
      .then(
        nickname => {
          this.setState({
            nickname: nickname
          });
        }
      )
  }

  handleSubmit(){
    this.authApi.signOut()
    .then(
      () => {
        this.props.history.push('/login');
      }
    );
  }

  handleDrawerOpen = () => {
    this.setState({ open: true });
  };

  handleDrawerClose = () => {
    this.setState({ open: false });
  };

  handleClickListItem = (path) => {
    console.log("path: ", path);
    this.setState({
      path: path
    })
  }

  render() {
    const { classes, theme } = this.props;

    return (
      <BrowserRouter>
        <Switch>
        <Route exact path='/login' component={Login} />
        <Fragment>
          <div className={classes.root}>
            <CssBaseline />
            <AppBar
              position="fixed"
              className={classNames(classes.appBar, {
                [classes.appBarShift]: this.state.open,
              })}
            >
              <Toolbar disableGutters={!this.state.open}>
                <IconButton
                  color="inherit"
                  aria-label="Open drawer"
                  onClick={this.handleDrawerOpen}
                  className={classNames(classes.menuButton, {
                    [classes.hide]: this.state.open,
                  })}
                >
                  <MenuIcon/>
                </IconButton>
                <img border="0" src="../images/manekineko.png" style={{marginRight:10, textAlign:'center', width: 32, height: 32, filter:"invert(100%)"}} alt="logo" />
                <Typography variant="title" color="inherit" noWrap style={{fontFamily:'Nico Moji'}}>
                  Manekineko
                </Typography>
                <div style={{display: this.state.nickname ? 'block' : 'none', margin: '0 0 0 auto', paddingRight: 20}}>
                  { this.state.nickname + ' さんでログイン中'  }
                </div>

              </Toolbar>
            </AppBar>
            <Drawer
              variant="permanent"
              className={classNames(classes.drawer, {
                [classes.drawerOpen]: this.state.open,
                [classes.drawerClose]: !this.state.open,
              })}
              classes={{
                paper: classNames({
                  [classes.drawerOpen]: this.state.open,
                  [classes.drawerClose]: !this.state.open,
                }),
              }}
              open={this.state.open}
            >
              <div className={classes.toolbar}>
                <IconButton onClick={this.handleDrawerClose}>
                  {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                </IconButton>
              </div>
              <Divider />
              <List>
                <ListItem button component={Link} to='/main/calendar' onClick={() => this.handleClickListItem('/main/calendar')} selected={this.state.path === '/main/calendar' ? true : false}>
                  <ListItemIcon><SvgIcon size={20} icon={calendar}/></ListItemIcon>
                  <ListItemText primary="空室情報" />
                </ListItem>
                <ListItem button component={Link} to='/main/reservation' onClick={() => this.handleClickListItem('/main/reservation')} selected={this.state.path === '/main/reservation' ? true : false}>
                  <ListItemIcon><SvgIcon size={20} icon={phone}/></ListItemIcon>
                  <ListItemText primary="予約受付" />
                </ListItem>
                <ListItem button component={Link} to='/main/reservation-manage' onClick={() => this.handleClickListItem('/main/reservation-manage')} selected={this.state.path === '/main/reservation-manage' ? true : false}>
                  <ListItemIcon><SvgIcon size={20} icon={listUl}/></ListItemIcon>
                  <ListItemText primary="予約管理" />
                </ListItem>
                <ListItem button component={Link} to='/main/checked-in-manage' onClick={() => this.handleClickListItem('/main/checked-in-manage')} selected={this.state.path === '/main/checked-in-manage' ? true : false}>
                  <ListItemIcon><SvgIcon size={20} icon={bellO}/></ListItemIcon>
                  <ListItemText primary="チェックイン管理" />
                </ListItem>
                <ListItem button component={Link} to='/main/input-order' onClick={() => this.handleClickListItem('/main/input-order')} selected={this.state.path === '/main/input-order' ? true : false}>
                  <ListItemIcon><SvgIcon size={20} icon={glass}/></ListItemIcon>
                  <ListItemText primary="オーダー入力" />
                </ListItem>
                <ListItem button component={Link} to='/main/issue-receipts' onClick={() => this.handleClickListItem('/main/issue-receipts')} selected={this.state.path === '/main/issue-receipts' ? true : false}>
                  <ListItemIcon><SvgIcon size={20} icon={fileTextO}/></ListItemIcon>
                  <ListItemText primary="領収書発行" />
                </ListItem>
                <ListItem button component={Link} to='/main/checked-out-manage' onClick={() => this.handleClickListItem('/main/checked-out-manage')} selected={this.state.path === '/main/checked-out-manage' ? true : false}>
                  <ListItemIcon><SvgIcon size={20} icon={checkSquareO}/></ListItemIcon>
                  <ListItemText primary="チェックアウト管理" />
                </ListItem>
                <ListItem button component={Link} to='/main/search-customers' onClick={() => this.handleClickListItem('/main/search-customers')} selected={this.state.path === '/main/search-customers' ? true : false} style={{marginBottom:30}}>
                  <ListItemIcon><SvgIcon size={20} icon={users}/></ListItemIcon>
                  <ListItemText primary="顧客検索" />
                </ListItem>
                <Divider />
                <ListItem button component={Link} to='/main/config' onClick={() => this.handleClickListItem('/main/config')} selected={this.state.path === '/main/config' ? true : false}>
                  <ListItemIcon><SvgIcon size={20} icon={gear}/></ListItemIcon>
                  <ListItemText primary="設定" />
                </ListItem>
                <ListItem button component={Link} to='/main/user-manage' onClick={() => this.handleClickListItem('/main/user-manage')} selected={this.state.path === '/main/user-manage' ? true : false}>
                  <ListItemIcon><SvgIcon size={20} icon={user}/></ListItemIcon>
                  <ListItemText primary="ユーザ管理" />
                </ListItem>
                <ListItem button component={Link} to='/main/extra-plans' onClick={() => this.handleClickListItem('/main/extra-plans')} selected={this.state.path === '/main/extra-plans' ? true : false}>
                  <ListItemIcon><SvgIcon size={20} icon={leaf}/></ListItemIcon>
                  <ListItemText primary="追加プラン管理" />
                </ListItem>
              </List>
              <Divider />
              <form onSubmit={(event) => this.handleSubmit(event)} style={{textAlign: 'center', marginTop: 20, backgroundColor: '#dedede'}}>
                <ListItem button type="submit" component="button">
                  <ListItemIcon><ExitToApp/></ListItemIcon>
                  <ListItemText primary="Logout" />
                </ListItem>
              </form>
            </Drawer>
            <main className={classes.content}>
              <div className={classes.toolbar} />
                <Switch>
                  <PrivateRoute exact path="/main/calendar" component={Calendar} setNickname={() => this.setNickname()} setPath={() => this.setPath()}/>
                  <PrivateRoute exact path="/main/reservation" component={Reservation} setPath={() => this.setPath()}/>
                  <PrivateRoute exact path="/main/reservation-manage" component={ReservationManage} setPath={() => this.setPath()}/>
                  <PrivateRoute exact path="/main/checked-in-manage" component={CheckedInManage}/>
                  <PrivateRoute exact path="/main/input-order" component={InputOrder}/>
                  <PrivateRoute exact path="/main/issue-receipts" component={IssueReceipts}/>
                  <PrivateRoute exact path="/main/checked-out-manage" component={CheckedOutManage}/>
                  <PrivateRoute exact path="/main/search-customers" component={SearchCustomers}/>
                  <PrivateRoute exact path="/main/config" component={Config}/>
                  <PrivateRoute exact path="/main/user-manage" component={UserManage}/>
                  <PrivateRoute exact path="/main/extra-plans" component={ExtraPlans}/>
                  <Redirect to="/main/calendar" />
                </Switch>
            </main>
          </div>
        </Fragment>
        <Redirect to="/main/reservation" />
        </Switch>
      </BrowserRouter>

    );
  }
}

App.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(App);
